import { GlobalAxios } from "../axios/axios-config";
import { ITasyEstablishment } from "../models/tasy-establishment";

const TASY_ESTABLISHMENT_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/Establishment/Establishment";

export const tasyEstablishmentList = (params?: any) => {
  return GlobalAxios.get<ITasyEstablishment[]>(TASY_ESTABLISHMENT_ROUTE, {
    params,
  });
};
